import { type UseModalState } from "@clipboard-health/ui-components";
import { Diagnostic } from "@ionic-native/diagnostic";
import { isCapacitorPlatform } from "@src/appV2/lib/utils";

import { CameraPermissionErrorBottomSheet } from "../../components/CameraPermissionErrorBottomSheet";

interface DocumentCameraPermissionErrorBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentCameraPermissionErrorBottomSheet(
  props: DocumentCameraPermissionErrorBottomSheetProps
) {
  const { modalState } = props;

  return (
    <CameraPermissionErrorBottomSheet
      modalState={modalState}
      onGoToSettings={async () => {
        modalState.closeModal();

        if (isCapacitorPlatform()) {
          await Diagnostic.switchToSettings();
        }
      }}
    />
  );
}
